import type React from 'react';

import { Button } from '@crehana/compass.ui/button';

import { useCourseDetailTranslation } from '../hooks/useCourseDetailTranslation';

interface ErrorViewProps {
  onReload: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = ({ onReload }) => {
  const { t } = useCourseDetailTranslation();

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-w-screen tw-h-screen">
      <div>
        <h1 className="tw-mb-2.4">{t('ERROR_VIEW_MESSAGE')}</h1>
        <Button type="button" variant="primary" onClick={onReload}>
          {t('ERROR_VIEW_BUTTON')}
        </Button>
      </div>
    </div>
  );
};

export default ErrorView;
